import CostAllocation from '@/domains/Test/views/CostAllocation/CostAllocationView';
import AdditionalPassengers from '@/domains/Test/views/AdditionalPassengers/AdditionalPassengersView';
import AdditionalDrivers from '@/domains/Test/views/AdditionalDrivers/AdditionalDriversView';
import TestView from './TestView';

const TestRoutes = [
  {
    path: 'cost-allocations',
    name: 'test.cost-allocation',
    component: CostAllocation,
  },
  {
    path: 'additional-passengers',
    name: 'test.additional-passengers',
    component: AdditionalPassengers,
  },
  {
    path: 'additional-drivers',
    name: 'test.additional-drviers',
    component: AdditionalDrivers,
  },
];

export default [
  {
    path: '/',
    redirect: { name: 'test' },
  },
  {
    path: '/test',
    name: 'test',
    redirect: { name: 'test.cost-allocation' },
    component: TestView,
    children: TestRoutes,
  },
];
